module.exports = __webpack_public_path__ + "media/images-example/1-097a2ed1.jpg";